import { render, staticRenderFns } from "./PeiboInstructions.vue?vue&type=template&id=2c208912&scoped=true"
import script from "./PeiboInstructions.vue?vue&type=script&lang=js"
export * from "./PeiboInstructions.vue?vue&type=script&lang=js"
import style0 from "./PeiboInstructions.vue?vue&type=style&index=0&id=2c208912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c208912",
  null
  
)

export default component.exports